import React, { useEffect, useState } from 'react';
import { adminApi } from '../../lib/adminApi';
import SocialSettings from './SocialSettings';
import SocialGenerator from './SocialGenerator';
import SocialPosts from './SocialPosts';
import SocialWeekly from './SocialWeekly';
import SocialCalendar from './SocialCalendar';
import { Link2, Unlink } from 'lucide-react';

export default function SocialPanel() {
  const [posts, setPosts] = useState([]);
  const [metaOk, setMetaOk] = useState(false);

  const load = () => adminApi.get('/admin/social/posts').then((r) => setPosts(r.data.items)).catch(() => {});
  useEffect(() => {
    load();
    adminApi.get('/admin/social/status').then((r) => setMetaOk(r.data.meta_connected)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!posts.some((p) => p.status === 'generating')) return undefined;
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [posts]);

  return (
    <div className="space-y-6" data-testid="social-panel">
      <div className={`rounded-xl p-4 flex items-start gap-3 border ${metaOk ? 'bg-green-500/10 border-green-500/30' : 'bg-yellow-500/10 border-yellow-500/30'}`}
        data-testid="meta-status-banner">
        {metaOk ? <Link2 className="text-green-400 mt-0.5 shrink-0" size={18} /> : <Unlink className="text-yellow-400 mt-0.5 shrink-0" size={18} />}
        <p className={`text-sm ${metaOk ? 'text-green-200/90' : 'text-yellow-200/90'}`}>
          {metaOk
            ? <><strong>Meta collegato.</strong> Puoi pubblicare su Instagram e Facebook e il feed Instagram appare sul sito.</>
            : <><strong>Meta non ancora collegato.</strong> Puoi già creare post con l'AI, scaricarli e copiarli. Pubblicazione diretta e feed sul sito si attivano quando colleghi Pagina Facebook + Instagram Business.</>}
        </p>
      </div>
      <SocialGenerator onCreated={(p) => setPosts((prev) => [p, ...prev])} />
      <SocialWeekly onCreated={(items) => setPosts((prev) => [...items, ...prev])} />
      <SocialCalendar posts={posts} />
      <SocialPosts posts={posts} metaOk={metaOk} reload={load} />
      <SocialSettings />
    </div>
  );
}
